<template>
  <div v-loading="listLoading" element-loading-text="拼命加载中...">
    <div class="filter" style="margin-top:-30px;">
      <el-tabs type="border-card" class="card-tab">
        <el-tab-pane label="拨号记录">
          <el-form :model="param" :inline="true" label-width="200px" class="formInline" size="mini">
            <div class="slide-wrap" style="height: auto;">
              <el-form-item label="拨打人姓名">
                <el-input v-model="param.callerName" placeholder="请输入所在拨打人姓名..."></el-input>
              </el-form-item>
              <el-form-item label="拨打人账号">
                <el-input v-model="param.callerAccount" placeholder="请输入拨打人账号..."></el-input>
              </el-form-item>
              <el-form-item label="拨出页面">
                <el-select v-model="param.callPage" filterable placeholder="请选择拨出页面...">
                  <el-option :label="item.name" :value="item.name" v-for="(item,index) in chooseCallPage"
                             :key="index"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="促销员姓名">
                <el-input v-model="param.salesmanName" placeholder="请输入促销员姓名..."></el-input>
              </el-form-item>
              <el-form-item label="促销员ID">
                <el-input v-model="param.empPk" placeholder="请输入促销员ID..."></el-input>
              </el-form-item>
              <el-form-item label="项目编号">
                <el-input v-model="param.projectCode" placeholder="请输入项目编号..."></el-input>
              </el-form-item>
              <el-form-item label="项目名称">
                <el-input v-model="param.projectName" placeholder="请输入项目名称..."></el-input>
              </el-form-item>
              <el-form-item label="所属部门">
                <el-input v-model="param.projectDepartment" placeholder="请输入所属部门..."></el-input>
              </el-form-item>
              <el-form-item label="手机号码">
                <el-input v-model="param.salesmanTel" placeholder="请输入手机号码..."></el-input>
              </el-form-item>
              <el-form-item label="日期">
                <el-date-picker value-format="yyyy-MM-dd" v-model="param.callDateBegin" type="date"></el-date-picker> -
                <el-date-picker value-format="yyyy-MM-dd" v-model="param.callDateEnd" type="date"></el-date-picker>
              </el-form-item>
            </div>
            <hr style="margin-bottom: 9px;">
            <div class="slide-btns clearfix">
              <el-form-item>
                <el-button type="text" class="reset-btn" @click="resetParams">清空</el-button>
                <el-button class="search-btn" @click="searchData">筛选</el-button>
                <el-button class="search-btn" @click="exportData">导出</el-button>
              </el-form-item>
            </div>
          </el-form>
        </el-tab-pane>
      </el-tabs>
      <div class="tableBody">
        <el-table class="limitManagerTable table-expand" style="width: 100%;" size="small" border :data="tableData">
          <el-table-column width="50" type="index" label="#" align="center"></el-table-column>
          <el-table-column width="100" prop="callerName" label="拨打人姓名" align="center"></el-table-column>
          <el-table-column width="100" prop="callerAccount" label="拨打人账号" align="center"></el-table-column>
          <el-table-column width="100" prop="callPage" label="拨出页面" align="center"></el-table-column>
          <el-table-column width="100" prop="salesmanName" label="促销员姓名" align="center"></el-table-column>
          <el-table-column width="100" prop="empPk" label="促销员id" align="center"></el-table-column>
          <el-table-column width="140" prop="projectCode" label="促销员所属项目编号" align="center"></el-table-column>
          <el-table-column width="120" prop="projectName" label="项目名称" align="center"></el-table-column>
          <el-table-column width="100" prop="projectDepartment" label="项目所属部门" align="center"></el-table-column>
          <el-table-column width="110" prop="salesmanTel" label="促销员真实号码" align="center"></el-table-column>
          <el-table-column width="90" prop="callDate" label="拨打日期" align="center"></el-table-column>
          <el-table-column width="90" prop="callTime" label="拨打时间" align="center"></el-table-column>
          <el-table-column width="110" prop="bellTime" label="响铃时长（秒）" align="center"></el-table-column>
          <el-table-column width="90" prop="isResponse" label="是否应答" align="center"></el-table-column>
          <el-table-column width="90" prop="talkTime" label="通话时长" align="center"></el-table-column>
          <el-table-column width="90" label="通话录音" align="center">
            <template slot-scope="scope">
              <a v-if="scope.row.recode == '--'" class="buttonText">--</a>
              <a v-else :href="scope.row.recode" target="_blank" class="buttonText">录音</a>
            </template>
          </el-table-column>
          <el-table-column width="100" prop="unitPrice" label="单价（元）" align="center"></el-table-column>
          <el-table-column width="100" prop="amount" label="金额（元）" align="center"></el-table-column>
        </el-table>
        <el-pagination class="pagination table-pagination" @size-change="handleSizeChange"
                       @current-change="handleCurrentChange" :current-page="formData.pageNo"
                       :page-sizes="[10, 20, 50, 100]" :page-size="formData.pageSize"
                       layout="slot,sizes, total,  prev, pager, next, jumper" :total="formData.total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import utils from '../../common/js/util.js'
  export default {
    name: "dummyPhoneRecode",
    data() {
      return {
        param: {
          callerName: null, // 拨打人姓名
          callerAccount: null, // 拨打人账号
          callPage: null, // 拨出页面
          salesmanName: null, // 促销员姓名
          empPk: null, // 促销员id
          projectCode: null, // 项目编号
          projectName: null, // 项目名称
          projectDepartment: null, // 项目所属部门
          salesmanTel: null, // 促销员真实号码
          callDateBegin: null, // 选择开始日期
          callDateEnd: null, // 选择结束日期
          sysUserId: null, // 当前用户id
          pageSize: null,
          pageNo: null
        },
        formData: {
          pageNo: 1,
          pageSize: 10,
          total: null
        },
        tableData: [],
        chooseCallPage: [
          {name: '不限', id: null},
          {name: "促销员库", id: 1},
          {name: "岗位管理", id: 0}
        ],
        listLoading: false,
      }
    },
    mounted() {
      this.getData();
    },
    methods: {
      // 翻页
      handleSizeChange(value) {
        this.formData.pageSize = value;
        this.getData();
      },
      handleCurrentChange(value) {
        this.formData.pageNo = value;
        this.getData();
      },
      getData() {
        this.listLoading = true;
        this.param.pageNo = this.formData.pageNo;
        this.param.pageSize = this.formData.pageSize;
        this.param.sysUserId = sessionStorage.getItem("sysUserId");
        this.$http({
          method: 'get',
          url: '/rest/JiangYiJoint/dummyPhoneRecodes',
          params: this.param
        }).then(res => {
          if (res.data && res.data.code == '0') {
            var data = res.data.data;
            this.formData.total = data.totalCount;
            this.tableData = data.results;
          }
          this.listLoading = false;
        }).catch(err => {
          console.log(err);
          this.listLoading = false;
        });
      },
      resetParams() {
        this.param.callerName = null;
        this.param.callerAccount = null;
        this.param.callPage = null;
        this.param.salesmanName = null;
        this.param.empPk = null;
        this.param.projectCode = null;
        this.param.projectName = null;
        this.param.projectDepartment = null;
        this.param.salesmanTel = null;
        this.param.callDateBegin = null;
        this.param.callDateEnd = null;
      },
      searchData() {
        this.formData.pageNo = 1;
        this.getData();
      },
      exportData() {
        this.listLoading = true;
        this.param.sysUserId = sessionStorage.getItem("sysUserId");
        this.$http({
          method: 'GET',
          url: '/rest/JiangYiJoint/dummyPhoneRecodes/export',
          params: this.param,
        }).then(res => {
          if(res.data && res.data.status == 200) {
            this.listLoading = false;
            location.href = utils.returnUrlHead() + res.data.data;
          }else {
            this.listLoading = false;
            this.$alert(res.data.message);
          }
        }).catch(error => {
          console.log(error)
          this.listLoading = false;
          this.$alert("导出错误，请联系管理员！");
        });
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/personnelCenter/dummyPhoneRecode.vue